import React, { Component } from 'react';
import {
  Paper,
  Button,
  Typography,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableFooter,
  TablePagination,
  Grid
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { withApollo } from '@apollo/client/react/hoc';
import AddIcon from '@material-ui/icons/Add';
import TextTruncate from 'react-text-truncate';

import TablePaginationActions from './TablePaginationActions';
import EditGroupButton from './EditGroupButton';
import DeleteGroupButton from './DeleteGroupButton';
import GroupDialog from './GroupDialog';

import { SearchGroups } from '../queries/searchGroups';

const styles = (theme) => ({
  root: {
    padding: theme.spacing(2)
  },
  leftIcon: {
    marginRight: theme.spacing(1)
  }
});

class GroupListing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 0,
      rowsPerPage: 10,
      createFormOpen: false,
      editFormOpen: false,
      search: '',
      groups: []
    };
  }

  _handleChangePage = (event, page) => {
    this.setState({ page });
  };

  _handleChangeRowsPerPage = (event) => {
    this.setState({ page: 0, rowsPerPage: event.target.value });
  };

  _refresh = () => {
    window.location = '/groups';
  };

  _executeSearch = async () => {
    let { search } = this.state;
    let result = await this.props.client.query({
      query: SearchGroups,
      variables: { search }
    });
    let groups = result.data.allGroups;
    this.setState({ groups });
  };

  _searchFilter = async (search) => {
    await this.setState({ search });
    this._executeSearch();
  };

  _handleCreateGroup = () => {
    this.setState({ createFormOpen: true });
  };

  _handleFormClose = () => {
    this.setState({ createFormOpen: false });
  };

  componentDidMount() {
    this._executeSearch();
  }

  render() {
    const { classes } = this.props;
    const { rowsPerPage, page, groups } = this.state;

    return (
      <Paper square className={classes.root}>
        <Grid justifyContent="space-between" container>
          <Grid item>
            <Typography variant="h5">All Groups</Typography>
          </Grid>
          <Grid item>
            <Typography variant="body1" align="right">
              <Button onClick={this._handleCreateGroup}>
                <AddIcon className={classes.leftIcon} />
                Create New Group
              </Button>
            </Typography>
            <TextField
              label="Search"
              margin="normal"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  this._searchFilter(e.target.value);
                }
              }}
            />
          </Grid>
        </Grid>
        <Table className={classes.table} aria-labelledby="tableTitle">
          <TableHead>
            <TableRow>
              <TableCell key="name">Name</TableCell>
              <TableCell key="roles">Roles</TableCell>
              <TableCell key="boards">Boards</TableCell>
              <TableCell key="actions" align="right">
                Actions
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {groups
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((group) => {
                return (
                  <TableRow hover tabIndex={-1} key={group.id}>
                    <TableCell>{group.name}</TableCell>
                    <TableCell>
                      {group.roles.map((v) => v.name).join(', ')}
                    </TableCell>
                    <TableCell>
                      <TextTruncate
                        line={1}
                        element="div"
                        truncateText="…"
                        text={group.boards.map((v) => v.name).join(', ')}
                      />
                    </TableCell>
                    <TableCell align="right">
                      <EditGroupButton group={group} />
                      <DeleteGroupButton
                        groupId={group.id}
                        refresh={this._refresh}
                      />
                    </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
          <TableFooter>
            <TableRow>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25, 50]}
                colSpan={6}
                count={groups.length}
                rowsPerPage={rowsPerPage}
                page={page}
                SelectProps={{ native: true }}
                onChangePage={this._handleChangePage}
                onChangeRowsPerPage={this._handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
              />
            </TableRow>
          </TableFooter>
        </Table>
        <GroupDialog
          newGroup
          group={{}}
          open={this.state.createFormOpen}
          formCloseHandler={this._handleFormClose}
          submitHandler={this._refresh}
        />
      </Paper>
    );
  }
}
export default withStyles(styles)(withApollo(GroupListing));
